import { useDashboardData } from './DashboardDataContext';
import { useDashboardUI } from './DashboardUIContext';

export { DashboardDataProvider, useDashboardData } from './DashboardDataContext';
export { DashboardUIProvider, useDashboardUI } from './DashboardUIContext';
export { DashboardScrollProvider, useDashboardScroll } from './DashboardScrollContext';

/** Hook de compatibilidad que combina ambos contextos (para componentes que necesitan data + UI) */
export const useDashboardBuilder = () => {
  const data = useDashboardData();
  const ui = useDashboardUI();
  return { ...data, ...ui };
};
